export default __webpack_public_path__ + "static/media/oss-logo.1e6fdd49.svg";